import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { CircularProgress } from '@mui/material';
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import { useAcademicYear } from "./AcademicYearContext";



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CreateProduct({
  staffId1,
  staffName,
  selectedIssueProductId,
  roleName,
  deleteFlag,
  setOpenComponent,
  setOpenComponentCreateSale,
  getSales,

  statusCreatedId,
  issueDescription,
  selectedIssueProductId: propsIssueProductId,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [product, setProduct] = useState([]);
  const [issueProductId, setIssueProductId] = useState(null);
  const [userId, setUserId] = useState();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("issue_product_details_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [validationErrors, setValidationErrors] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState({});
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [saleStatus, setSaleStatus] = useState([]);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [createdStatusId, setCreatedStatusId] = useState(null);
  const [openProduct, setOpenProduct] = useState(false);
  const [error, setError] = useState(""); // Error message state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchStaff, setSearchStaff] = useState("");
  const [searchResultsForStaff, setSearchResultsForStaff] = useState([]);
  const [staffName1, setStaffName1] = useState(staffName);
  const [roleName1, setRoleName1] = useState(roleName);
  const [staffId, setStaffId] = useState(staffId1);
  const [debouncedstaff, setDebouncedstaff] = useState("");
  const [IssueDescription, setIssueDescription] = useState("");


  const [openstaff, setOpenstaff] = useState(false);
  const [loadingstaff, setLoadingstaff] = useState(false); // Loading state
  const [loadingProduct, setLoadingProduct] = useState(false); // Loading state  
  const [needsReturn, setNeedsReturn] = useState(true)
  const [openNeedsReturn, setOpenNeedsReturn] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [allStaffData, setAllStaffData] = useState([]);
  const [description, setDescription] = useState(issueDescription || '');
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasUnsavedDescription, setHasUnsavedDescription] = useState(false);
  const [productSearchError, setProductSearchError] = useState("");
  


  const navigate = useNavigate();
  const { academicYearId } = useAcademicYear();

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  useEffect(() => {
    if (selectedIssueProductId) {
      setIssueProductId(selectedIssueProductId);
    }
  }, [selectedIssueProductId]);
  useEffect(() => {

      // ✅ Don't overwrite if user has unsaved changes
  if (hasUnsavedDescription) {
    return;
  }

    // Priority 1: Use issueDescription prop from parent (when editing)
    if (issueDescription) {
      setDescription(issueDescription);
    }
    // Priority 2: Use IssueDescription from getProduct API call
    else if (IssueDescription) {
      setDescription(IssueDescription);
    }
    // Priority 3: Clear for new entries
    else if (statusCreatedId !== createdStatusId) {
      setDescription('');
    }
  }, [issueDescription, IssueDescription, statusCreatedId, createdStatusId]);


  const handleCheckboxClick = async () => {
    try {
      const newNeedsReturnValue = !needsReturn; // Toggle the current value

      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/createProduct/updateNeedsReturn",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            issue_product_id: issueProductId,
            needs_return: newNeedsReturnValue, // Send toggled value
            updated_by: userId,
            updated_timestamp: new Date(),
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update data");

      const data = await response.json();
      console.log("Success:", data);

      setNeedsReturn(newNeedsReturnValue); // Update state with toggled value
    } catch (error) {
      console.error("Error:", error);
    }
    setOpenNeedsReturn(false);
  };


  // const handleProceed = () => {
  //   console.log("proceed funcntion clciked ");
  //   handleOk();
  //   setOpenComponent(false);
  //   setOpenComponentCreateSale(false);
  //   getSales();

  // };

  const handleProceed = async () => {
  console.log("proceed function clicked");
   // ✅ Validation: Check if staff is selected but no products
  if (staffName1 && product.length === 0) {
    setProductSearchError("Please select product(s) before proceeding.");
    return;
  }
  
  try {
    await handleOk(); // ✅ Wait for update
    await getSales(); // ✅ Wait for refresh
    
    setOpenComponent(false);
    setOpenComponentCreateSale(false);
  } catch (error) {
    console.error("Error in handleProceed:", error);
    setError("Failed to save changes");
    setSnackbarOpen(true);
  }
};

  const handleCloseProduct = () => {
    setOpenProduct(false);
  };

  const handleCloseNeedsReturn = () => {
    setOpenNeedsReturn(false);
  };

  const handleOpenNeedsReturn = () => {
    if (issueProductId) {
      setOpenNeedsReturn(true);
    }
  };

  const handleClosestaff = () => {
    setOpenstaff(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }

        );
        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);



  useEffect(() => {
    const fetchProducts = async () => {
      setLoadingProduct(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getsearchresult`
        );
        if (!response.ok) throw new Error("Failed to fetch products");
        const data = await response.json();
        setAllProducts(data);
        setSearchResults([]); // initially show nothing
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoadingProduct(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    const filtered = allProducts.filter((row) =>
      searchTerms.every(
        (term) =>
          (row.product_id &&
            row.product_id.toString().toLowerCase().includes(term)) ||
          (row.product_name &&
            row.product_name.toLowerCase().includes(term)) ||
          (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
          (row.attribute_name &&
            row.attribute_name.toLowerCase().includes(term)) ||
          (row.attribute_value &&
            row.attribute_value.toLowerCase().includes(term)) ||
          (row.price && row.price.toString().toLowerCase().includes(term)) ||
          (row.quantity && row.quantity.toString().toLowerCase().includes(term))
      )
    );

    setSearchResults(filtered);
  }, [searchQuery, allProducts]);

  useEffect(() => {
    const fetchAllStaff = async () => {
      setLoadingstaff(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/getsearchresultforstaff`
        );
        if (!response.ok) throw new Error("Failed to fetch staff");
        const data = await response.json();
        setAllStaffData(data);
      } catch (error) {
        console.error("Error fetching staff:", error);
      } finally {
        setLoadingstaff(false);
      }
    };

    fetchAllStaff();
  }, []);

  useEffect(() => {
    const searchTerms = searchStaff.toLowerCase().split(" ").filter(Boolean);

    const filtered = allStaffData.filter((row) =>
      searchTerms.every(
        (term) =>
          (row.id && row.id.toString().toLowerCase().includes(term)) ||
          (row.first_name && row.first_name.toLowerCase().includes(term)) ||
          (row.last_name && row.last_name.toLowerCase().includes(term)) ||
          (row.role_name && row.role_name.toLowerCase().includes(term)) ||
          (row.contact_no && row.contact_no.toString().includes(term))
      )
    );

    setSearchResultsForStaff(filtered);
  }, [searchStaff, allStaffData]);

  useEffect(() => {
    getProduct();
  }, []);

  useEffect(() => {
    getProduct();
  }, [staffId, academicYearId]);
  const getProduct = async () => {
    console.log("staffId", staffId)
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT +
        "/createProduct/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
          body: JSON.stringify({
            issued_to_staff_id: staffId,
            academic_year_id: academicYearId,
          }),
        }
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin")
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Filter out products where the description is "Paid" or "Issued"
      const filteredData = data.filter(
        (item) => item.description !== "Paid" && item.description !== "Issued" && item.description !== "Returned" && item.description !== "Partial Return"
      );

      // Update state with filtered data
      setProduct(filteredData);
      setTableData(filteredData);

      // Handle sales ID and sales details only if there are valid products
      if (filteredData.length > 0) {
        setIssueProductId(filteredData[0].issue_product_id);
        setNeedsReturn(filteredData[0].needs_return);
        setIssueDescription(filteredData[0].issue_description || '');
        console.log("needsReturn", filteredData[0].needs_return);
        console.log("issueDescription", filteredData[0].issue_description); // Add this log to verify
      } else {
        // Clear these states if no valid products remain
        setIssueProductId(null);
        setNeedsReturn(true); // Reset to default
        setIssueDescription(''); // Clear description
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }


      const data = await response.json();

      // Extract specific sale_status_id for descriptions "Paid" and "Issued"
      const createdStatus =
        data.find((item) => item.description === "Created")?.issue_product_status_id ||
        null;
      const issuedStatus =
        data.find((item) => item.description === "Issued")?.issue_product_status_id ||
        null;

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setCreatedStatusId(createdStatus);
      setIssuedStatusId(issuedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleInput = () => {
    setOpenstaff(true);
  };

  const handleSearchForstaff = (event) => {
    setSearchStaff(event.target.value);
  };

  const handleProductSelect = (product) => {
    // Check if the product is already in the table data
    const isAlreadyAdded = tableData.some(
      (item) => item.product_id === product.product_id
    );

    if (isAlreadyAdded) {
      // Show an error message for duplicate products with product details
      const productDetails = `${product.product_name}${product.attribute_name ? ' - ' + product.attribute_name : ''}${product.attribute_value ? ': ' + product.attribute_value : ''}`;
      setError(`This product is already added`);
      setSnackbarOpen(true);

      return; // Exit the function to avoid further execution
    }

    // Check if the product stock is zero or less
    if (product.quantity <= 0) {
      setError("This product is out of stock.");
      setSnackbarOpen(true);
      console.log("Error: Out of stock.");
      return; // Exit the function to avoid further execution
    }

    // Add the product to the table
    setTableData((prev) => [...prev, product]);
    setSearchQuery(""); // Clear search input
    setSearchResults([]); // Clear search results
    handleRowClick(product);
    // setError(""); // Clear any existing error message
  };

  const handleStaffSelect = (staff) => {
    console.log("staff id", staff.id)
    setStaffId(staff.id);

    setStaffName1(`${staff.first_name} ${staff.last_name}`);
    setRoleName1(staff.role_name);

    setSearchStaff(""); // Clear search input
    setSearchResultsForStaff([]); // Clear search results
    setError(""); // Clear any existing error message
    setIssueProductId(null);
    setNeedsReturn(true);
    setHasUnsavedDescription(false);
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // Replace the handleRowClick function in CreateProduct.jsx with this:

  const handleRowClick = async (product) => {
    console.log("staffId", staffId)

    // ✅ Store current description
  const currentDescription = description;

    try {
      // First, create a new sale entry
      const createResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/addSale`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            academicYearId,
            created_by: userId,
            issue_product_status_id: createdStatusId,
            issueProductId,
            issued_to_staff_id: staffId,
            issue_description: description, // ✅ Add this line to pass description
          }),
        }
      );

      const createResult = await createResponse.json();

      // Extract sales ID from the response
      const newissueProductId = createResult.data.issue_product_id;
      setIssueProductId(newissueProductId);
      console.log("newissueProductId", newissueProductId)

      // Send sales details
      const detailsResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/addSaleDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product_id: product.product_id,
            quantity: 1,
            issue_product_id: newissueProductId,
            created_by: userId,
            issue_product_status: createdStatusId,
            return_quantity: 0,
          }),
        }
      );

      const detailsResult = await detailsResponse.json();
    
    await getProduct();
    
    // ✅ Restore description
    setDescription(currentDescription);
    setProductSearchError("");
    
  } catch (error) {
      console.error("Error:", error);
    }
  };


  const handleRowDeleteClick = (sale) => {
    setMarkedForDelete((prev) => {
      const isAlreadyMarked = prev.includes(sale);
      const updatedMarkedForDelete = isAlreadyMarked
        ? prev.filter((id) => id !== sale) // Remove if already marked
        : [...prev, sale]; // Add if not marked


      // Update selectedRow based on marking status
      if (isAlreadyMarked) {
        setSelectedRow(null); // Clear selection if unselecting
      } else {
        setSelectedRow({ sale }); // Update selection
      }

      return updatedMarkedForDelete; // Update markedForDelete state
    });
  };

  useEffect(() => {
    console.log("Updated marked for delete:", markedForDelete);
  }, [markedForDelete]);

  const handleBatchDelete = () => {
    if (issueProductId) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setMarkedForDelete("");
  };

  const handleDeleteConfirm = async () => {
    if (markedForDelete.length === 0) return; // Ensure there are selected rows

    try {
      // Iterate over each sales_details_id to delete them
      for (const sale of markedForDelete) {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/deleteSaleDetails`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: 'include',
            body: JSON.stringify({ issue_product_details_id: sale }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete sale details."); // Handle errors
        }

        if (response.status === 401) {
          console.warn("Unauthorized access. Redirecting to Sign In...");
          navigate("/signin")
          return; // Stop further execution
        }
        const result = await response.json();
      }
      // Refresh product data after deletion
      getProduct();

      // Clear the selected rows and close the dialog
      setMarkedForDelete([]);
      setOpen(false);
      setTimeout(() => {
        setSelectedRow(null);
      }, 1000);
    } catch (error) {
      console.error("Error deleting sale details:", error);
      setErrorMessage(error.message); // Display error message
    }
  };

  // Function to delete sale details by sales_details_id
  const deleteSaleDetails = async (salesDetailsId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/deleteSaleDetails`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
          body: JSON.stringify({ issue_product_details_id: salesDetailsId }),
        }
      );


      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error(
          `Failed to delete sale details with ID ${salesDetailsId}.`
        );
      }

      console.log(
        `Sale details with ID ${salesDetailsId} deleted successfully.`
      );
    } catch (error) {
      console.error("Error deleting sale details:", error);
      setErrorMessage(error.message);
    }
  };

  const deleteInvalidProducts = async () => {
    try {
      if (!product || product.length === 0) {
        console.warn("deleteData is empty or undefined.");
        return;
      }

      // Iterate through each object in the deleteData array
      for (const data of product) {
        // Ensure required fields exist
        if (
          !data.issue_product_details_id ||
          !data.stock ||
          data.description !== "Created"
        ) {
          continue;
        }

        // Parse `sales_details_id` and `stock` into arrays
        const salesDetailsIds = data.issue_product_details_id.split(",");
        const stocks = data.stock.split(",");

        // Find indices where stock is "0"
        const invalidIndices = stocks
          .map((stock, index) => (Number(stock) === 0 ? index : -1))
          .filter((index) => index !== -1);

        // Get the corresponding `sales_details_id` for invalid products
        const invalidSalesDetailsIds = invalidIndices.map(
          (index) => salesDetailsIds[index]
        );

        // Delete products where stock is "0" and description is "Created"
        for (const salesDetailsId of invalidSalesDetailsIds) {
          await deleteSaleDetails(salesDetailsId); // Your function to delete the product
        }
      }

      // Refresh product data after deletion
      // await getProduct();
    } catch (error) {
      console.error("Error during invalid product deletion:", error);
      setErrorMessage(error.message);
    }
  };

  // useEffect to delete invalid products when selectedIssueProductId is present
  useEffect(() => {
    if (deleteFlag) {
      deleteInvalidProducts(); // Call to delete invalid products if selectedIssueProductId is present
    }
  }, [deleteFlag]); // Dependency on selectedIssueProductId



  // Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = () => {
    return product.slice().sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleQuantityChange = async (
    salesDetailsId,
    value,
    maxQuantity,
    productId
  ) => {
    // Parse the input to a number
    const numericValue = parseInt(value, 10);

    // Step 1: Validation checks
    if (value === "" || isNaN(numericValue)) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity is required and must be between 1 and ${maxQuantity}`,
      }));
      setSelectedQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: "",
      }));
      return;
    }

    if (numericValue < 1) {
      setValidationErrors((prev) => ({
        ...prev,
        // [salesDetailsId]: "Quantity must be at least 1.",
      }));
      return;
    }

    if (numericValue > maxQuantity) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity cannot exceed available stock.`,
      }));
      return;
    }

    // Step 2: Clear validation errors if all checks pass
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: null,
    }));

    // Step 3: Update the selected quantity in the local state
    setSelectedQuantity((prev) => ({
      ...prev,
      [salesDetailsId]: numericValue,
    }));

    try {
      // Update sales quantity in the backend
      const updateResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/updateQuantity`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
          body: JSON.stringify({
            issue_product_details_id: salesDetailsId,
            quantity: numericValue,
            updated_by: userId,
            updated_timestamp: new Date(),
          }),
        }
      );

      if (!updateResponse.ok) {
        throw new Error("Failed to update sales data");
      }

      getProduct();
      setCurrentQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: numericValue,
      }));
      // updateTotalPrice();
    } catch (error) {
      console.error("Error during update:", error);
      // alert(error.message);
    }
  };

  const handleOk = async () => {
    console.log("handle ok function clicked");

    try {
      // Determine which issue_product_id to use
      let activeIssueProductId;

      if (selectedIssueProductId) {
        activeIssueProductId = selectedIssueProductId;
      } else if (issueProductId) {
        activeIssueProductId = issueProductId;
      } else {
        console.error("No issue_product_id available");
        return;
      }

      // ✅ Check if this is a Created status record
      const isCreatedStatus = statusCreatedId === createdStatusId;

      console.log("Is Created Status:", isCreatedStatus);
      console.log("statusCreatedId:", statusCreatedId);
      console.log("createdStatusId:", createdStatusId);

         // ✅ NEW LOGIC: Use createdStatusId if clicking from non-Created status
    if (createdStatusId && statusCreatedId !== createdStatusId) {
      // Editing from Issued/Returned/Partial Return → Update the Created record
      activeIssueProductId = createdStatusId;
      console.log("Updating Created record from non-Created status:", createdStatusId);
    } else if (selectedIssueProductId) {
      // Editing directly from Created status
      activeIssueProductId = selectedIssueProductId;
    } else if (issueProductId) {
      // New record being created
      activeIssueProductId = issueProductId;
    } else {
      console.error("No issue_product_id available");
      return;
    }

      console.log("Using issue_product_id:", activeIssueProductId);
      console.log("Description:", description);
      console.log("User ID:", userId);

      const apiUrl = `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/updateIssueDescription`;
      console.log("API URL:", apiUrl);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          issue_product_id: activeIssueProductId,
          issue_description: description,
          updated_by: userId,
          updated_timestamp: new Date().toISOString(),
        }),
      });

      if (response.ok) {
        console.log("✅ Description updated successfully");
        setOpenComponent(false);
        setOpenComponentCreateSale(false);
        getSales();
      } else {
        const errorData = await response.json();
        console.error("❌ Description update failed:", errorData);
        setError(errorData.message || "Failed to update description");
        // setSnackbarOpen(true);
      }


      // First, update description
      const createResponse = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/updatedescription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            issueProductId,
            issue_description: description, // ✅ Add this line to pass description
          }),
        }
      );


if (createResponse.ok) {
  console.log("✅ Updated description in staff by handleok function");
  setHasUnsavedDescription(false); // ✅ Clear flag
  return true;
}
    } catch (error) {
      console.error("🔥 Error in handleOk:", error);
      setError("An error occurred while updating description");
      // setSnackbarOpen(true);
    }
  };



  return (
    <div>
      {!staffName && (
        <div className="create_search">
          {/* Search Field and Proceed Button */}
          <div style={{ display: "flex" }}>
            <div className="create_search1">
              <TextField
                sx={{ minWidth: 700, marginBottom: "4px", }}
                label="Staff Search"
                variant="outlined"
                fullWidth
                value={searchStaff}
                onChange={handleSearchForstaff}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton type="button" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {loadingstaff ? <CircularProgress size={18} /> : null}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </div>
      )}

      {searchStaff.trim() !== "" && searchResultsForStaff.length > 0 && (
        <List
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "0",
            width: 600,
          }}
        >
          {searchResultsForStaff.map((staff) => (
            <ListItem
              button
              key={staff.id}
              onClick={() => handleStaffSelect(staff)}
            >
              <ListItemText primary={staff.first_name} />
              <ListItemText primary={staff.last_name} />
              <ListItemText primary={staff.role_name} />
            </ListItem>
          ))}
        </List>
      )}

      <div className="main_title1">
        Staff Name: {staffName1} &nbsp;&nbsp; Role: {roleName1}
      </div>

      {/* Description field - Always editable */}
      <div>
        <TextField
          label="Description"
          multiline
          rows={2}
          variant="outlined"
          value={description}
          // onChange={(e) => setDescription(e.target.value)}
          onChange={(e) => {
  setDescription(e.target.value);
  setHasUnsavedDescription(true);
}}
          // ✅ Remove the disabled prop - keep it always editable
          placeholder={issueDescription || "Enter description"}
          sx={{
            minWidth: 700,
            marginTop: "20px",
            "& .MuiOutlinedInput-root": {
              padding: "8px",
            },
            "& .MuiInputLabel-root": {
              color: "#484f53ff",
            },
          }}
        />

      </div>

      {/* Indent ID - Always show heading, show value only when products exist */}
      <div
        style={{
          margin: "20px 0",
          fontSize: 15,
          fontWeight: "bold",
          color: "#0A64A2",
          paddingTop: "0",
        }}
      >
        Indent ID: {product.length > 0 ? (issueProductId || selectedIssueProductId) : ""}
      </div>

      <div className="create_search" >
        {/* Search Field and Proceed Button */}
        <div style={{ display: "flex" }}>
          <div className="create_search1" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <TextField
              sx={{ minWidth: 700, marginBottom: "4px" }}
              
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={staffName1 ? handleSearchChange : handleInput} // Conditional onChange
                label={productSearchError ? productSearchError : "Product Search"}
        error={!!productSearchError}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loadingProduct ? <CircularProgress size={18} /> : null}
                  </InputAdornment>
                ),
              }}
            />
            <Checkbox

              checked={!needsReturn}
              //  disabled = {needsReturn}
              onChange={() => handleOpenNeedsReturn()} />Returnable

          </div>
          <div className="sale-div">
            <div className="sale-delete-div">
              <Button
                variant="contained"
                color="primary"
                onClick={handleProceed}
                className="sale-delete-btn"
              >
                OK
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBatchDelete}
                className="sale-delete-btn"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>

        {/* Search Results List */}
        {searchQuery.trim() !== "" && searchResults.length > 0 && (
          <List
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "0",
              width: 700,
            }}
          >
            {searchResults.map((product) => (
              <ListItem
                button
                key={product.id}
                onClick={() => handleProductSelect(product)}
              >
                <ListItemText primary={product.product_name} />
                <ListItemText primary={product.attribute_name} />
                <ListItemText primary={product.attribute_value} />
                <ListItemText primary={product.price} />
                <ListItemText primary={product.quantity} />
              </ListItem>
            ))}
          </List>
        )}
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <TableSortLabel
                  active={orderBy === "issue_product_details_id"}
                  direction={orderBy === "issue_product_details_id" ? order : "asc"}
                  onClick={() => handleSort("issue_product_details_id")}
                >
                  Sl.No</TableSortLabel></StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "product_name"}
                  direction={orderBy === "product_name" ? order : "asc"}
                  onClick={() => handleSort("product_name")}
                >
                  Product Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_name"}
                  direction={orderBy === "attribute_name" ? order : "asc"}
                  onClick={() => handleSort("attribute_name")}
                >
                  Attribute Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_value"}
                  direction={orderBy === "attribute_value" ? order : "asc"}
                  onClick={() => handleSort("attribute_value")}
                >
                  Attribute Value{" "}
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center">

                Quantity{" "}

              </StyledTableCell>

              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                  Quantity In Stock
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {

                return (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell
                      align="center"
                      component="th"
                      scope="row"
                      className="table-cell-border"
                    >
                      {row.issue_product_details_id}
                      {markedForDelete.includes(row.issue_product_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.product_name}
                      {markedForDelete.includes(row.issue_product_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_name}
                      {markedForDelete.includes(row.issue_product_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_value}
                      {markedForDelete.includes(row.issue_product_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      <div>
                        <input
                          type="number"
                          value={
                            selectedQuantity[row.issue_product_details_id] !== undefined
                              ? selectedQuantity[row.issue_product_details_id]
                              : row.quantity || 1 // Fallback to row.quantity if state is undefined
                          }
                          onChange={(e) =>
                            handleQuantityChange(
                              row.issue_product_details_id,
                              e.target.value,
                              row.stock,
                              row.product_id
                            )
                          }
                          style={{ width: "60px" }}
                          defaultValue={1}
                        />
                        {validationErrors[row.issue_product_details_id] && (
                          <div style={{ color: "red", marginTop: "5px" }}>
                            {validationErrors[row.issue_product_details_id]}
                          </div>
                        )}
                      </div>
                      {markedForDelete.includes(row.issue_product_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.stock}
                      {markedForDelete.includes(row.issue_product_details_id) && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    {/* Display calculated total price */}
                    <StyledTableCell
                      align="center"
                      style={{ lineHeight: "10px", padding: "5px" }}
                    >
                      <IconButton
                        color="black"
                        onClick={() =>
                          handleRowDeleteClick(row.issue_product_details_id)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}

            {/* Row to display total price */}

          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        style={{ backgroundColor: "#0A64A2", color: "#fff" }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={product.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/* 
         

          {/* Delete Confirmation Dialog */}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {markedForDelete.length > 0
              ? "Are you sure you want to delete this selected Product(s)?"
              : "Please select product(s) before deleting."}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          {markedForDelete.length > 0 ? (
            <Button
              variant="contained"
              onClick={handleDeleteConfirm}
              className="no-btn"
            >
              Yes
            </Button>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            onClick={handleClose}
            autoFocus
            className="no-btn"
          >
            {markedForDelete.length > 0 ? "No" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Product Selection Dialog */}
      <Dialog
        open={openProduct}
        onClose={handleCloseProduct}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Please select product(s) before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCloseProduct}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* staff Selection Dialog */}
      <Dialog
        open={openstaff}
        onClose={handleClosestaff}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Kindly select a Staff member before selecting any products.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleClosestaff}
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* Needs Return Dialog */}
      <Dialog
        open={openNeedsReturn}
        onClose={handleCloseNeedsReturn}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {needsReturn
              ? `Are you sure you want to mark Indent Id ${issueProductId} returnable?`
              : `Are you sure you want to mark Indent Id ${issueProductId} non-returnable?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCheckboxClick}
            autoFocus
            className="no-btn"
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={handleCloseNeedsReturn}
            autoFocus
            className="no-btn"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for errors */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={handleCloseSnackbar}
          severity="error"
          variant="filled"
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}
